import React from 'react';
import {
  Page,
  Text,
  View,
  StyleSheet,
} from '@react-pdf/renderer';
import { style } from '../../../components/pdf/fontstyles';

const styles = StyleSheet.create({
 
});

const PensionLetterPDF = ({result}) => (
  <View size="A4" style={style.page}>
    {/* Header */}
    <View>
      <Text style={[style.subtitle, {fontSize: 8,marginBottom:0}]} >
        Pension Scheme for the Teaching Staff in Non-Government Secondary Schools
      </Text>
      <Text style={[style.subtitle, {fontSize: 8, marginTop:0}]}>
        (vide G.R.E. & S.W.D.NO. SSN3365-G, dated 4th November 1968)
      </Text>
    </View>
    <Text style={[style.title, style.ArialBlack]} >
        ANNEXURE II
    </Text>

    <Text style={[style.subtitle]}>
        (a) Remarks by the Receiving Authority)
    </Text>

    <View style={style.solidLine}/>


    {/* Dispatch Line */}
   <View style={{ flexDirection: 'row', marginBottom: 10 }}>
  {/* Questions Column */}
  <View style={{ width: '65%' }}>
    <Text>1. As to character and past conduct of applicant</Text>
    <Text>2. Explanation of any suspension or degradation</Text>
    <Text>3. Regarding any gratuity or pension already received by applicant</Text>
    <Text>4. Any other remarks :</Text>
    <Text>5. Specific opinion of the receiving authority whether the service claim is established and should be admitted or not</Text>
  </View>
  
  {/* Answers Column */}
  <View style={{ width: '30%' }}>
    <Text>: Good & Satisfactory</Text>
    <Text>: NO</Text>
    <Text>: Nil</Text>
    <Text>: Nil</Text>
    <Text>: Pension may be sanctioned</Text>
  </View>
</View>

<Text style={{ fontSize: 8, fontStyle: 'italic', marginLeft: 10 }}>
  (See Rule 198 A (ii) 207 B (a) (ii))
</Text>

<Text style={style.signature}>Head of Office</Text>

<Text style={[style.paragraph, {marginTop:10, marginBottom:0}]}>Countersigned by Education Officer {result.educationOfficer}</Text>
<Text style={[style.paragraph,]}>Zilla Parishad {result.educationOfficer}</Text>
   
    {/* Para 1 */}
    <View style={[style.paragraph, {marginTop: 5}]}>
      <Text>b) Orders of the Pension Sanctioning Authority - The undersigned having satisfied himself that the service of {result.employeeName} has been thoroughly satisfactory, hereby orders the grant of the full pension and /or gratuity all commence form.</Text>
    </View>

    <View style={[style.paragraph]}>
      <Text>    A sum of Rs. Nil on account of Nil is to be held over form the Death cum retirement gratuity till the outstanding dues are assessed and adjusted.</Text>
    </View>
    <View style={[style.paragraph, {marginTop: 2}]}>
      <Text>    The undersigned having satisfied himself that the Service of {result.employeeName} has not been thoroughly satisfactory, hereby orders the grant of the full pension and /or gratuity which may be accepted by the Accountant General as admissible under the rules shall be reduced by specified amounts or percentage indicated below.</Text>
    </View>

    <View style={{ marginTop: 1, marginLeft: 10 }}>
  {/* Each Text component is a separate paragraph */}
  <Text style={{ fontSize: 10 }}>
    Amount of the percentage of reduction in pension -Nil
  </Text>
  
  <Text style={{ fontSize: 10 }}>
    Amount of the percentage of reduction in gratuity -Nil
  </Text>
  
  <Text style={{ fontSize: 10 }}>
    The grant of this pension and / or gratuity shall take effect from is to be held over from the death cum retirement gratuity till outstanding dues are assessed and adjusted.
  </Text>
  
  <Text style={{ fontSize: 10 }}>
    The pension and death cum retirement gratuity are payable at ------------- and are chargeable to
  </Text>
  
</View>

<View>
  <Text style={{ fontSize: 10 }}>
    <Text style={{ marginLeft: 20 }}>T</Text>his order is subject to the condition that, it should the amount of pension and/or gratuity as authorized by accountant General be afterwards found to be in excess of the amounts to which the pensioner is entitled under the rule.
    He/She will be called upon to refund such excess. A declaration from the Government servant accepting this condition has obtained/is enclosed/a declaration from the Government servant accepting this condition will be obtained and submitted separately.
  </Text>
</View>

<Text style={style.signature}>Signature and Designation of the
Authority sanctioning</Text>

<Text style={style.subtitle}>(a) Audit Enforcement</Text>
<View style={{fontSize: 8}}>
    <Text>1.
Total period of duty/ qualifying service which has been accepted for the grant of superannuation / retiring invalid / compensation / pension/ death cum-retirement gratuity, with reasons for disallowance if and other than disallowance, if and other than disallowance, if any, of service the reasons for which are recorded by the Audit Officer on the second / Third page.
Note - Service for the period commencing from and up to the date of retirement has not
</Text>
<Text>2.
Amount of superannuation retiring invalid / compensation / death cum retirement gratuity that has been admitted.
</Text>
<Text>
3.
Amount of superannuation retiring invalid / compensation / death cum retirement gratuity admissible after Taking into account the reduction on pension and gratuity made by the authority sanctioning pension.
</Text>
<Text>
4.
The date from which the superannuation / retiring / pension and gratuity made by the authority sanctioning pension.
</Text>
<Text>
5.
Head of Account to which the superannuation retiring and special additional pension / death cum retirement gratuity is chargeable.
</Text>

</View>
<Text style={style.signature}>Accountant General</Text>
</View>
);

export default PensionLetterPDF;
